import {
    ActionStatus,
    CodedProperty,
    FailureSeverity,
    NamedProperty,
    ValidationFailure,
    createFailure,
    depascalize
} from "sprint-common-web";

import { OnPremOrderStatus } from "../../../../common/types/OnPremOrderStatus";

export interface UpdateOnPremOrderStatusRequestItem {
    id: string;
    content?: string;
    pONumber: string;
    airline?: CodedProperty;
    system?: NamedProperty;
    status: OnPremOrderStatus;
}

export type ProcessUpdateOrderStatusRequestItem = UpdateOnPremOrderStatusRequestItem & {
    processStatus: ActionStatus;
};

const orderedStr = depascalize(OnPremOrderStatus[OnPremOrderStatus.Ordered]);
const assetAssignedStr = depascalize(OnPremOrderStatus[OnPremOrderStatus.AssetAssigned]);
const partialAssetAssignedStr = depascalize(OnPremOrderStatus[OnPremOrderStatus.PartialAssetAssigned]);
const readyToSendStr = depascalize(OnPremOrderStatus[OnPremOrderStatus.ReadyToSend]);
const encodedStr = depascalize(OnPremOrderStatus[OnPremOrderStatus.Encoded]);
const recalledStr = depascalize(OnPremOrderStatus[OnPremOrderStatus.Recalled]);

const getDiscardedOrdersInfoMessage = (status?: OnPremOrderStatus): string => {
    switch (status) {
        case OnPremOrderStatus.Ordered:
            return `Orders with statuses other than ${assetAssignedStr} and ${partialAssetAssignedStr}, have been discarded`;
        case OnPremOrderStatus.PartialAssetAssigned:
            return `Orders with statuses other than ${orderedStr} and ${assetAssignedStr}, have been discarded`;
        case OnPremOrderStatus.AssetAssigned:
            return `Orders with statuses other than ${orderedStr} and ${partialAssetAssignedStr}, have been discarded`;

        case OnPremOrderStatus.Recalled:
        case OnPremOrderStatus.Encoded: {
            return `Orders with statuses other than ${orderedStr}, ${partialAssetAssignedStr} and ${assetAssignedStr}, have been discarded`;
        }
        case OnPremOrderStatus.ReadyToSend:
            return `Orders with statuses other than ${encodedStr} and ${recalledStr}, have been discarded`;

        case OnPremOrderStatus.SentToOem: {
            return `Orders with statuses other than ${readyToSendStr}, have been discarded`;
        }
        default:
            return "";
    }
};

export const validateDiscardedItems = (
    items: UpdateOnPremOrderStatusRequestItem[],
    selectedItemsCount: number,
    status?: OnPremOrderStatus
): ValidationFailure | void => {
    if (!items.length) {
        return createFailure(
            `${getDiscardedOrdersInfoMessage(status)}. Nothing to send.`,
            "no-orders-to-deliver",
            FailureSeverity.Error
        );
    } else if (items.length < selectedItemsCount) {
        return createFailure(
            `${getDiscardedOrdersInfoMessage(status)}.`,
            "order-discarded-from-status-update",
            FailureSeverity.Warning
        );
    }
};
